import { FooterWidgetWrapper } from "components/Footer";
import { Form } from "components/Forms";
import { buildWidgetInstanceId } from "features/widgets";
import { WIDGETS_REGISTRY } from "features/widgets/widgets.config";

import styles from "./Footer003.module.scss";

export const Footer003 = ({ payload }) => {
  const formType = payload?.formType ?? {};
  const template = payload?.template ?? "light";

  const instanceId = buildWidgetInstanceId(
    "003",
    payload.id,
    WIDGETS_REGISTRY.FOOTER
  );

  return (
    <FooterWidgetWrapper className={styles[template]}>
      <Form item={formType} instanceId={instanceId} />
    </FooterWidgetWrapper>
  );
};

export default Footer003;
